import parameterController from "@/services/parameterService";
import Swal from "sweetalert2";

const PARAM_ID = 6;

export default {
  name: "CoaView",

  data() {
    return {
      items: [],
      total: 0,
      loading: false,

      page: 1,
      perPage: 10,
      perPageOptions: [10, 25, 50, 100],
      totalPages: 1,

      filters: {
        search: "",
        status: "",
      },

      showModal: false,
      isEdit: false,
      saving: false,
      formError: "",

      form: {
        id: null,
        param_id: PARAM_ID,
        description: "",
        value: 1,
        is_active: 1,
      },

      errors: {
        description: "",
        value: "",
      },

      toast: {
        show: false,
        message: "",
        type: "success",
      },
      toastTimer: null,
    };
  },

  computed: {
    visiblePages() {
      const total = this.totalPages;
      const current = this.page;
      const delta = 2;
      const range = [];

      for (
        let i = Math.max(2, current - delta);
        i <= Math.min(total - 1, current + delta);
        i++
      ) {
        range.push(i);
      }

      if (current - delta > 2) range.unshift("...");
      if (current + delta < total - 1) range.push("...");

      range.unshift(1);
      if (total > 1) range.push(total);

      return range;
    },
  },
  mounted() {
    this.getData();
  },

  methods: {
    async getData() {
      this.loading = true;

      const result = await parameterController.getAll({});

      // Ambil semua data dari response
      const allData = result?.data?.data ?? result?.data ?? [];

      // Filter hanya param_id = 6
      let filtered = allData.filter((item) => item.param_id === PARAM_ID);

      // Filter search (by description)
      if (this.filters.search) {
        const q = this.filters.search.toLowerCase();
        filtered = filtered.filter((item) =>
          item.description?.toLowerCase().includes(q),
        );
      }

      // Filter status (is_active) — jika API mendukung field ini
      if (this.filters.status !== "") {
        const s = parseInt(this.filters.status);
        filtered = filtered.filter((item) =>
          item.is_active !== undefined ? item.is_active == s : true,
        );
      }

      this.total = filtered.length;
      this.totalPages = Math.ceil(this.total / this.perPage) || 1;

      if (this.page > this.totalPages) this.page = this.totalPages;

      const start = (this.page - 1) * this.perPage;
      this.items = filtered.slice(start, start + this.perPage);

      this.loading = false;
    },

    changePerPage() {
      this.page = 1;
      this.getData();
    },
    changePage(p) {
      if (p < 1 || p > this.totalPages) return;
      this.page = p;
      this.getData();
    },

    openModal() {
      this.isEdit = false;
      this.formError = "";
      this.clearErrors();
      this.form = {
        id: null,
        param_id: PARAM_ID,
        description: "",
        value: this.total + 1,
        is_active: 1,
      };
      this.showModal = true;
    },
    openEdit(item) {
      this.isEdit = true;
      this.formError = "";
      this.clearErrors();
      this.form = {
        id: item.id,
        param_id: PARAM_ID,
        description: item.description,
        value: item.value,
        is_active: item.is_active ?? 1,
      };
      this.showModal = true;
    },
    closeModal() {
      if (this.saving) return;
      this.showModal = false;
      this.formError = "";
      this.clearErrors();
    },
    validateForm() {
      this.clearErrors();
      let valid = true;

      if (!this.form.description?.trim()) {
        this.errors.description = "Label COA tidak boleh kosong.";
        valid = false;
      } else if (this.form.description.trim().length > 100) {
        this.errors.description = " maksimal 100 karakter.";
        valid = false;
      }

      if (!this.form.value || this.form.value < 1) {
        this.errors.value = "Urutan harus berupa angka positif.";
        valid = false;
      }

      return valid;
    },

    clearErrors() {
      this.errors = {
        description: "",
        value: "",
      };
    },

    async saveForm() {
      if (!this.validateForm()) return;

      this.saving = true;
      try {
        this.formError = "";

        const payload = {
          param_id: PARAM_ID,
          description: this.form.description.trim(),
          value: this.form.value,
          is_active: this.form.is_active,
        };

        let result;

        if (this.isEdit) {
          result = await parameterController.update(this.form.id, payload);
        } else {
          result = await parameterController.create(payload);
        }
        if (result.success) {
          this.saving = false;
          this.closeModal();
          this.page = 1;
          this.getData();
          this.showToast(
            this.isEdit
              ? "Label COA berhasil diperbarui."
              : "Label COA berhasil ditambahkan.",
            "success",
          );
        } else {
          this.formError = result.message || "Gagal menyimpan data.";
        }
      } catch (err) {
        console.error(err);
        this.formError =
          err.response?.data?.message || err.message || "Gagal menyimpan data.";
      } finally {
        this.saving = false;
      }
    },

    async toggleStatus(item) {
      const newStatus = item.is_active == 1 ? 0 : 1;
      const action = newStatus === 1 ? "mengaktifkan" : "menonaktifkan";
      const label = newStatus === 1 ? "diaktifkan" : "dinonaktifkan";

      const confirm = await Swal.fire({
        title: "Konfirmasi",
        text: `Yakin ingin ${action} Label COA  ini?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: "Ya",
        cancelButtonText: "Batal",
        confirmButtonColor: "#198754",
      });

      if (!confirm.isConfirmed) return;

      const result = await parameterController.updateStatus(item.id, newStatus);

      if (result.success) {
        this.getData();
        this.showToast(`Label COA berhasil ${label}.`, "success");
      } else {
        this.showToast(result.message || "Gagal mengubah status.", "danger");
      }
    },

    showToast(message, type = "success") {
      if (this.toastTimer) clearTimeout(this.toastTimer);
      this.toast = { show: true, message, type };
      this.toastTimer = setTimeout(() => {
        this.toast.show = false;
      }, 3000);
    },
  },

  beforeUnmount() {
    if (this.toastTimer) clearTimeout(this.toastTimer);
  },
};
